import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class Store extends EventDrivenStore {
  constructor() {
    const defaultState = {
      list_all: {
        list: [],
        error: null,
        loading: true
      },
    };

    super('affiliation', defaultState);
    this.defaultState = defaultState;
  }

  async setupEvents() {
    this.on(constants.EVENTS.AFFILIATION.LIST_ALL.REFRESHING, () => {
      this.state.list_all.loading = true;
      this.state.list_all.error = null;
    });

    this.on(constants.EVENTS.AFFILIATION.LIST_ALL.REFRESHED, (data) => {
      this.state.list_all.list = Array.isArray(data) ? data : [];
      this.state.list_all.loading = false;
      this.state.list_all.error = Array.isArray(data)
        ? null
        : 'Mauvais format de donnée';
    });

    this.on(constants.EVENTS.AFFILIATION.LIST_ALL.REFRESH_ERROR, (error) => {
      this.state.list_all.loading = false;
      this.state.list_all.error = error?.message || error;
      this.state.list_all.list = [];
    });
  }
}

export default Store;
